export default {
  FILTER_MANAGED_STUDENT_LIST: 'FilterManagedStudentList',
  LOAD_MANAGED_STUDENT_LIST_START: 'LoadManagedStudentListStart',
  LOAD_MANAGED_STUDENT_LIST_END: 'LoadManagedStudentListEnd',
  LOAD_MANAGED_STUDENT_LIST_STATUSES: 'LoadManagedStudentListStatuses'
};